import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        periods: '=',
        manage: '&'
    },
    template: `
        <table class="data01" datatable dt-options="vm.DATATABLES">
            <thead>
            <tr>
                <th>
                    {{ 'licence.Entering deadline' | translate }}
                    <small>({{ 'licence.Acquiring deadline' | translate }})</small>
                </th>
                <th>{{ 'licence.Required points' | translate }}</th>
                <th>{{ 'licence.Collected points' | translate }}</th>
                <th class="none dt-hide">{{ 'licence.Collected points' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="period in vm.periods">
                <td>
                    {{ period.enteringDate | date : 'dd.MM.yyyy' }}
                    <small>({{ period.acquiringDate | date : 'dd.MM.yyyy' }})</small>
                    <span class="tag" ng-class="{
                        color01: vm.USER_LICENCE_STATUS_ENUM.KEYS.NOT_ACQUIRED===period.periodStatus,
                        color02: vm.USER_LICENCE_STATUS_ENUM.KEYS.ACQUIRED===period.periodStatus
                    }">{{ vm.USER_LICENCE_STATUS_ENUM.LABELS[period.periodStatus] }}</span>
                </td>
                <td>{{ period.pointsPerPeriod }}</td>
                <td>{{ period.collectedPoints }}</td>
                <td>
                    <div ng-non-bindable>
                        <user-employee-detail-licences-points></user-employee-detail-licences-points>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    `
})
export default class {
    constructor ($translate, $rootScope, lodash, DATATABLES, DatatableService, USER_LICENCE_STATUS_ENUM) {
        this.USER_LICENCE_STATUS_ENUM = USER_LICENCE_STATUS_ENUM;
        this.DATATABLES = lodash.merge({}, DATATABLES, DatatableService.getResponsiveOption(([rowIndex]) => {
            const $newScope = $rootScope.$new();
            $newScope.vm = this;
            $newScope.index = rowIndex;
            return $newScope;
        }));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/licences/periods/index.js